import FormInput from "./FormInput";
import FormInput2 from "./FormInput2";
import FormInputCurrency from "./FormInputCurrency";
import FormArray from "./FormArray";
import FormFile from "./FormFile";
import FormTextarea from "./FormTextarea";
import FormSelect from "./FormSelect";
import FormSelect2 from "./FormSelect2";
import FormCheckbox from "./FormCheckbox";
import FormCheckboxGroup from "./FormCheckboxGroup";
import FormDateTime from "./FormDateTime";
import InputDateTime from "./InputDateTime";
import FormImage from "./FormImage";
import FormEditor from "./FormEditor";
import FormRadioGroup from './FormRadioGroup';
import FormTagsInput from './FormTagsInput';
import 'font-awesome/css/font-awesome.min.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
    install(Vue) {
        Vue.component('form-input', FormInput);
        Vue.component('form-input-2', FormInput2);
        Vue.component('form-input-currency', FormInputCurrency);
        Vue.component('form-array', FormArray);
        Vue.component('form-file', FormFile);
        Vue.component('form-textarea', FormTextarea);
        Vue.component('form-select', FormSelect);
        Vue.component('form-select-2', FormSelect2);
        Vue.component('form-checkbox', FormCheckbox);
        Vue.component('form-checkbox-group', FormCheckboxGroup);
        Vue.component('form-date-time', FormDateTime);
        Vue.component('input-date-time', InputDateTime);
        Vue.component('form-image', FormImage);
        Vue.component('form-editor', FormEditor);
        Vue.component('form-radio-group', FormRadioGroup);
        Vue.component('form-tags-input', FormTagsInput);
    }
}